import React, { useEffect, useState } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";

export default function ShowNotif() {
  const location = useLocation();
  const { notifId } = location.state || {}; // Safely access notifId
  const baseUrl = useSelector((state) => state.gtm.baseUrl);


  const [notif, setNotif] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch notification details
  useEffect(() => {
    const fetchNotification = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${baseUrl}/show-notif/${notifId}`);
        setNotif(response.data.notification);
      } catch (error) {
        console.error("Error fetching notification:", error);
        setError("Failed to fetch notification. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };




    if (notifId) {
      fetchNotification();
      setIsLoading(false);
    }
  }, [notifId, baseUrl]);
console.log(isLoading,"hhhhhhhhh");

  if (isLoading) {
    return (
      <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-center items-center p-16 gap-8 w-full md:w-[100%] rounded-3xl py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="flex flex-col gap-12 min-h-screen"
        style={{
          backgroundImage: `url(${images.golf_field})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Nav />
        <div className="flex justify-center mx-16 mb-20">
          <div className="flex flex-col md:flex-row w-full justify-between items-start lg:gap-6 md:gap-0">
            <Sidebar />
            <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-center items-center p-16 gap-8 w-full md:w-[100%] rounded-3xl py-12">
              <div className="text-center text-3xl font-bold mb-6">
                <p>Error</p>
              </div>
              <div className="text-center text-xl">{error}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-start items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
      <div className="text-center text-3xl md:text-4xl font-bold mb-4 md:mb-6">
        <p>Notification</p>
      </div>
      <div className="text-start justify-start w-full md:w-[80%] items-center flex flex-col gap-4 md:gap-8 leading-relaxed md:leading-loose">
        <div className="text-end w-full font-bold text-sm md:text-base">
          {notif?.created_at
            ? `${notif.created_at.split("T")[0]} ${
                notif.created_at.split("T")[1].split(".")[0]
              }`
            : "N/A"}
        </div>
        <div className="font-bold w-full text-start text-lg md:text-xl">
          {notif?.title}
        </div>
        <div className="leading-relaxed md:leading-loose text-sm md:text-base">
          {notif?.message}
        </div>
        <div
          className="text-[#0D70A1] w-full text-center text-base md:text-xl mt-4 md:mt-6 font-bold cursor-pointer"
          onClick={() => window.history.back()}
        >
          Go back to historical notifications
        </div>
      </div>
    </div>
  );
}
